"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";
import {
     // start of about campaign
     incentiveAddAboutCampaignComplete,
     // end of about campaign
     incentiveListRequest,
     incentiveListComplete,
     incentiveDeleteComplete,
     incentiveTypesComplete,
     incentiveSearchListComplete,
     incentiveChangeStatusComplete,
     campaignTypesComplete,
     getCampaignParticipantsComplete,
     getCampaignSalesComplete,
     getCampaignTemplateTypeComplete,
     getCampaignProductComplete,
     participantListComplete,
     creationStepOneComplete,
     ajaxError,
     incentiveHeaderContentPublishComplete,
     incentiveHeaderContentGetComplete,
     incentiveHeaderContentGetListComplete,
     incentiveHeaderContentUpdateComplete,
     incentiveHeaderContentAddComplete,
     getParticipantDataTemplateComplete,
     getSalseDataTemplateComplete,
     updateAboutCampaignStepOneComplete,
     getAboutCampaignStepOneComplete,
     getAboutCampaignStepOneRequest,
     listCampaignParticipantsRequest,
     listCampaignParticipantsComplete,
     addCampaignParticipantsComplete,
     listCampaignAdminsComplete,
     addCampaignAdminsComplete,
     incentiveHeaderContentGetListRequest,
     incentiveAboutContentGetListComplete,
     incentiveQuickContentGetListComplete,
     incentiveQuickContentGetListRequest,
     incentiveQuickContentAddComplete,
     incentiveTermContentGetListComplete,
     incentiveTermContentGetListRequest,
     incentiveTermContentAddComplete,
     incentiveFaqContentGetListComplete,
     incentiveHeaderPublishedRevisionComplete,
     incentiveAboutPublishedRevisionComplete,
     incentiveQuickPublishedRevisionComplete,
     incentiveTermPublishedRevisionComplete,
     incentiveFaqPublishedRevisionComplete,
     incentiveAboutContentGetListRequest,
     incentiveAboutContentGetComplete,
     incentiveQuickContentGetComplete,
     incentiveTermContentGetComplete,
     incentiveFaqContentGetComplete,
     incentiveFaqContentAddComplete,
     incentiveFaqContentGetListRequest,
     incentiveAboutContentPublishComplete,
     incentiveQuickContentPublishComplete,
     incentiveTermContentPublishComplete,
     incentiveFaqContentPublishComplete,
     incentiveContentUnPublishComplete,
     incentiveHeaderPublishedRevisionRequest,
     incentiveAboutPublishedRevisionRequest,
     incentiveQuickPublishedRevisionRequest,
     incentiveTermPublishedRevisionRequest,
     incentiveFaqPublishedRevisionRequest,
} from "../_actions";

import { incentiveConstants } from "../_constants";

import { authConstants, requestTypes, factTableConstants } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

// start of about campaign epics

export const incentiveAddAboutCampaignEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_ADD_ABOUT_CAMPAIGN_REQUEST),
          mergeMap((action) => {
               const { form,page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/incentive/aboutContentAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )

                    .pipe(
                         concatMap((ajaxResponse) => {

                              form.reset();

                              return of(

                                   incentiveAddAboutCampaignComplete(
                                        ajaxResponse.response,
                                   ),

                                   incentiveAboutContentGetListRequest({
                                        page: 1,
                                        pageSize: 5,
                                        campaignId:payload.id,
                                        search: '',
                                   }),

                              );
                              
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveAboutContentGetListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_ABOUT_REVISION_CONTENT_LIST_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/aboutContentGetList",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveAboutContentGetListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveAboutPublishedRevisionGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_GET_ABOUT_PUBLISHED_REVISION_CONTENT_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/aboutPulishedContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveAboutPublishedRevisionComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveAboutContentGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_ABOUT_CONTENT_GET_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/aboutContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveAboutContentGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveAboutContentPublishEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_ABOUT_CONTENT_PUBLISH_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/aboutContentPublish",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(

                         concatMap((ajaxResponse) => {
                              return of(
                                   incentiveAboutContentPublishComplete(
                                        ajaxResponse.response,
                                   ),
                                   incentiveAboutContentGetListRequest({
                                        page: payload.page,
                                        pageSize: payload.rowsPerPage,
                                        campaignId:payload.campaignId,
                                        search:'',
                                   }),
                                   incentiveAboutPublishedRevisionRequest({
                                        campaignId:payload.campaignId,
                                   }),
                              );
                         }),


                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};



// end of about campaign epics

export const incentiveListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TABLE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/incentive/list",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              incentiveListComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_DELETE_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/incentive/delete",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   incentiveDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   incentiveListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/incentive/types",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveTypesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const campaignTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_CAMPAIGN_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/incentive/campaignTypes",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return campaignTypesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getCampaignParticipantsEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_CAMPAIGN_PARTICIPANTS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/incentive/getCampaignParticipants",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getCampaignParticipantsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getCampaignSalesEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_CAMPAIGN_SALES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/incentive/getCampaignSales",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getCampaignSalesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getCampaignTemplateTypeEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_CAMPAIGN_TEMPLATE_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/incentive/getCampaignTemplateType",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getCampaignTemplateTypeComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getCampaignProductEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_CAMPAIGN_PRODUCTS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/incentive/getCampaignProduct",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getCampaignProductComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const participantListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_PARTICIPANT_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/incentive/participantList",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return participantListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveSearchListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TABLE_SEARCH_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/incentive/search",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveSearchListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveChangeStatusEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_CHANGE_STATUS_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/incentive/change-status",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   incentiveChangeStatusComplete(
                                        ajaxResponse.response,
                                   ),
                                   incentiveListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveHeaderContentAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_HEADER_CONTENT_ADD_REQUEST),
          mergeMap((action) => {
               const { form, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/headerContentAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {

                              form.reset();

                              return of(

                                   incentiveHeaderContentAddComplete(
                                        ajaxResponse.response,
                                   ),

                                   incentiveHeaderContentGetListRequest({
                                        page: 1,
                                        pageSize: 5,
                                        campaignId:payload.id,
                                        search: '',
                                   }),

                              );
                              
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveHeaderContentUpdateEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_HEADER_CONTENT_EDIT_REQUEST),
          mergeMap((action) => {
               const { handleStep, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/creationStepOne",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              handleStep(1);
                              return creationStepOneComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveHeaderContentGetListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_HEADER_CONTENT_LIST_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/headerContentGetList",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveHeaderContentGetListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveHeaderContentGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_HEADER_CONTENT_GET_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/headerContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveHeaderContentGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveHeaderContentPublishEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_HEADER_CONTENT_PUBLISH_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/headerContentPublish",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(

                         concatMap((ajaxResponse) => {
                              return of(
                                   incentiveHeaderContentPublishComplete(
                                        ajaxResponse.response,
                                   ),
                                   incentiveHeaderContentGetListRequest({
                                        page: payload.page,
                                        pageSize: payload.rowsPerPage,
                                        campaignId:payload.campaignId,
                                        search:'',
                                   }),
                                   incentiveHeaderPublishedRevisionRequest({
                                        campaignId:payload.campaignId,
                                   }),
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveHeaderPublishedRevisionGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_GET_HEADER_PUBLISHED_REVISION_CONTENT_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/headerPulishedContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveHeaderPublishedRevisionComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const getParticipantDataTemplateEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_PARTICIPANT_DATA_TEMPLATE_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/incentive/getParticipantDataTemplate",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getParticipantDataTemplateComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getSalseDataTemplateEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_SALSE_DATA_TEMPLATE_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/incentive/getSalseDataTemplate",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getSalseDataTemplateComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const creationStepOneEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.CREATION_STEP_ONE_REQUEST),
          mergeMap((action) => {
               const { handleStep, navigate, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/creationStepOne",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              navigate(
                                   "/app/incentive-data-manage/add/" +
                                        ajaxResponse.response.id,
                              );

                              return of(
                                   creationStepOneComplete(
                                        ajaxResponse.response,
                                   ),
                                   getAboutCampaignStepOneRequest({
                                        id: ajaxResponse.response.id,
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const addCampaignAdminsEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.ADD_CAMPAIGN_ADMINS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/incentive/addCampaignAdmins",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return addCampaignAdminsComplete(
                                   ajaxResponse.response,
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const getAboutCampaignStepOneEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.GET_ABOUT_CAMPAIGN_STEP_ONE_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/getAboutCampaignStepOne",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getAboutCampaignStepOneComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const updateAboutCampaignStepOneEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.UPDATE_ABOUT_CAMPAIGN_STEP_ONE_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/updateAboutCampaignStepOne",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              return of(
                                   updateAboutCampaignStepOneComplete(
                                        ajaxResponse.response,
                                   ),
                                   listCampaignParticipantsRequest({
                                        id: payload.id,
                                   }),
                                   getAboutCampaignStepOneRequest({
                                        id: payload.id,
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const listCampaignParticipantsEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.LIST_CAMPAIGN_PARTICIPANTS_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/listCampaignParticipants",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return listCampaignParticipantsComplete(
                                   ajaxResponse.response,
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const addCampaignParticipantsEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.ADD_CAMPAIGN_PARTICIPANTS_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/addCampaignParticipants",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return addCampaignParticipantsComplete(
                                   ajaxResponse.response,
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const listCampaignAdminsEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.LIST_CAMPAIGN_ADMINS_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/getCampaignAdmins",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return listCampaignAdminsComplete(
                                   ajaxResponse.response,
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                         );
               }),
          );
     };

// start of quick campaign 


export const incentiveQuickContentAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_QUICK_CONTENT_ADD_REQUEST),
          mergeMap((action) => {
               const { form, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/quickContentAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    
                    .pipe(

                         concatMap((ajaxResponse) => {
                              
                         form.reset();
                              return of(

                                   incentiveQuickContentAddComplete(
                                        ajaxResponse.response,
                                   ),

                                   incentiveQuickContentGetListRequest({
                                        page: 1,
                                        pageSize: 5,
                                        campaignId:payload.id,
                                        search: '',
                                   }),
                         
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                         
                    );

                    
          }),
     );
};



export const incentiveQuickContentUpdateEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_QUICK_CONTENT_EDIT_REQUEST),
          mergeMap((action) => {
               const { handleStep, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/quickContentUpdate",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              handleStep(1);
                              return creationStepOneComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};




export const incentiveQuickContentGetListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_QUICK_REVISION_CONTENT_LIST_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/quickContentGetList",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveQuickContentGetListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveQuickContentGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_QUICK_CONTENT_GET_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/quickContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveQuickContentGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveQuickPublishedRevisionGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_GET_QUICK_PUBLISHED_REVISION_CONTENT_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/quickPulishedContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveQuickPublishedRevisionComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveQuickContentPublishEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_QUICK_CONTENT_PUBLISH_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/quickContentPublish",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(

                         concatMap((ajaxResponse) => {
                              return of(

                                   incentiveQuickContentPublishComplete(
                                        ajaxResponse.response,
                                   ),

                                   incentiveQuickContentGetListRequest({
                                        page: payload.page,
                                        pageSize: payload.rowsPerPage,
                                        campaignId:payload.campaignId,
                                        search:'',
                                   }),
                                   incentiveQuickPublishedRevisionRequest({
                                        campaignId:payload.campaignId,
                                   }),
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};



// end of quick campaign 

// start of terms and conditions

export const incentiveTermContentAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TERM_CONTENT_ADD_REQUEST),
          mergeMap((action) => {
               const { form, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/termsContentAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(

                         concatMap((ajaxResponse) => {
                              
                         form.reset();
                                                       return of(

                                   incentiveTermContentAddComplete(
                                        ajaxResponse.response,
                                   ),

                                   incentiveTermContentGetListRequest({
                                        page: 1,
                                        pageSize: 5,
                                        campaignId:payload.id,
                                        search: '',
                                   }),
                         
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                         
                    );

          }),
     );
};

export const incentiveTermContentUpdateEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TERM_CONTENT_EDIT_REQUEST),
          mergeMap((action) => {
               const { handleStep, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/termsContentUpdate",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              handleStep(1);
                              return creationStepOneComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveTermContentGetListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TERM_CONTENT_LIST_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/termsContentGetList",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveTermContentGetListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveTermContentGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TERM_CONTENT_GET_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/termsContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveTermContentGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};



export const incentiveTermPublishedRevisionGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_GET_TERM_PUBLISHED_REVISION_CONTENT_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/termPulishedContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveTermPublishedRevisionComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveTermContentPublishEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_TERM_CONTENT_PUBLISH_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/termContentPublish",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              return of(
                                   incentiveTermContentPublishComplete(
                                        ajaxResponse.response,
                                   ),
                                   incentiveTermContentGetListRequest({
                                        page: payload.page,
                                        pageSize: payload.rowsPerPage,
                                        campaignId:payload.campaignId,
                                        search:'',
                                   }),
                                   incentiveTermPublishedRevisionRequest({
                                        campaignId:payload.campaignId,
                                   }),
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


// end of terms and conditions


// start of faq


export const incentiveFaqContentAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_FAQ_CONTENT_ADD_REQUEST),
          mergeMap((action) => {
               const { form, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/freqContentAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {

                              form.reset();

                              return of(

                                   incentiveFaqContentAddComplete(
                                        ajaxResponse.response,
                                   ),

                                   incentiveFaqContentGetListRequest({
                                        page: 1,
                                        pageSize: 5,
                                        campaignId:payload.id,
                                        search: '',
                                   }),

                              );
                              
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveFaqContentUpdateEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_FAQ_CONTENT_EDIT_REQUEST),
          mergeMap((action) => {
               const { handleStep, ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/freqContentUpdate",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              handleStep(1);
                              return creationStepOneComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveFaqContentGetListEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_FAQ_CONTENT_LIST_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/freqContentGetList",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveFaqContentGetListComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const incentiveFaqContentGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_FAQ_CONTENT_GET_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/freqContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveFaqContentGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveFaqPublishedRevisionGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_GET_FAQ_PUBLISHED_REVISION_CONTENT_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/feqPulishedContentGet",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveFaqPublishedRevisionComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const incentiveFaqContentPublishEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_FAQ_CONTENT_PUBLISH_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/freqContentPublish",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(

                         concatMap((ajaxResponse) => {
                              return of(
                                   incentiveFaqContentPublishComplete(
                                        ajaxResponse.response,
                                   ),
                                   incentiveFaqContentGetListRequest({
                                        page: payload.page,
                                        pageSize: payload.rowsPerPage,
                                        campaignId:payload.campaignId,
                                        search:'',
                                   }),
                                   incentiveFaqPublishedRevisionRequest({
                                        campaignId:payload.campaignId,
                                   }),
                              );
                         }),

                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


// end of faq


export const incentiveContentUnPublishEpic = (actions$) => {
     return actions$.pipe(
          ofType(incentiveConstants.INCENTIVE_CONTENT_UNPUBLISH_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;
               return ajax
                    .post(
                         "/api/incentive/contentUnPublish",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return incentiveContentUnPublishComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

